import Vue from "vue";
import axios from "axios";

function staffInitialState() {
    return {
        data: {},
        filterId: "all",
        isFiltersVisible: true,
        sortings: {
            total: {
                field: "sum_fot",
                direction: "DESC"
            },
            department: {
                field: "wage_fund",
                direction: "DESC"
            }
        }
    };
}

export default {
    state: () => staffInitialState(),
    mutations: {
        setStaffFilter(state, id) {
            state.filterId = id;
        },
        toggleStaffFilters(state, isFiltersVisible) {
            state.isFiltersVisible = isFiltersVisible;
        },
        setStaffSortingField(state, { table, field }) {
            state.sortings[table].field = field;
        },
        setStaffSortingDirection(state, { table, direction }) {
            state.sortings[table].direction = direction;
        },
        setStaffData(state, data) {
            Vue.set(state, "data", data)
        },
        resetStaffState(state) {
            Object.assign(state, staffInitialState());
        }
    },
    actions: {
        requestStaff: ({ commit, rootState }) => axios.get("/report/ranking", {
            params: { key: rootState.auth.user.key }
        }).then(({ data }) => commit("setStaffData", data))
    }
};
